import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaVoidNode } from './TypedNode'
import { SchemaVoidModel } from './ViewModel'

export const SchemaVoidPlugin = createSchemaPlugin(
  'Schema.Void',
  SchemaVoidModel,
  SchemaVoidNode
)
